import { useState } from 'react';
import api from '../../services/api';
import { LifeCategory } from './types';

export const useCategoryOperations = (loadData: () => Promise<any>) => {
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  
  const [categoryForm, setCategoryForm] = useState({
    name: '',
    color: '#3b82f6',
    icon: '📁'
  });

  const handleCreateCategory = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post('/api/life-categories', categoryForm);
      setCategoryForm({ name: '', color: '#3b82f6', icon: '📁' });
      await loadData();
    } catch (error) {
      console.error('Failed to create category:', error);
      alert('Ошибка при создании категории');
    }
  };

  const handleDeleteCategory = async (categoryId: number) => {
    if (window.confirm('Удалить эту категорию? Цели и дела останутся, но потеряют связь с категорией.')) {
      try {
        await api.delete(`/api/life-categories/${categoryId}`);
        await loadData();
      } catch (error) {
        console.error('Failed to delete category:', error);
        alert('Ошибка при удалении категории');
      }
    }
  };

  const handleUpdateCategoryOrder = async (categoryId: number, newOrder: number) => {
    try {
      await api.put(`/api/life-categories/${categoryId}`, { order: newOrder });
      await loadData();
    } catch (error) {
      console.error('Failed to update category order:', error);
    }
  };

  return {
    showCategoryModal,
    setShowCategoryModal,
    categoryForm,
    setCategoryForm,
    handleCreateCategory,
    handleDeleteCategory,
    handleUpdateCategoryOrder
  };
};
